// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import TaxFilingStatusInput from '../tax-filing-status';

const TaxFilingStatusInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
}) => {
  return (
    <TaxFilingStatusInput
      label={label}
      tooltip={tooltip}
      className={className}
    />
  );
};

export default TaxFilingStatusInputWithAnalytics;
